<template>
    <h1 class="control-panel-title">Nieuwe sessie</h1>
    <div class="control-panel-content" v-if="newAdminCodes.length > 0">
        <div class="new-admin-code">
            <p>Nieuwe spelcodes:</p>
            <table class="table custom-table">
                <thead>
                    <tr>
                        <th>Email</th>
                        <th>Login code</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="adminCode in newAdminCodes" :key="adminCode">
                        <td><span class="large" @click="copyToClipboard(adminCode.email)">{{ adminCode.email }}</span></td>
                        <td><span class="large" @click="copyToClipboard(adminCode.adminCode)">{{ adminCode.adminCode }}</span></td>
                        <td><router-link :to="'/admin/sessions/' + adminCode.adminCode">Ga naar sessie</router-link></td>
                    </tr>
                </tbody>
            </table>
            <span class="small">Geef deze spelcodes en de e-mailadressen aan de spelers.</span>
        </div>
    </div>
    <div class="control-panel-content" v-else>
        <p>Hier kunt u een nieuwe spelsessie aanmaken.</p>
        <p class="error-message" v-if="errorMessage">{{ errorMessage }}</p>
        <div>
            <p class="labelGroupName">
                Groepsnaam:
            </p>
            <InputView v-model="groupName" :uppercase="false" hint="Groepsnaam" class="inputGroupName" />
        </div>
        <div style="display: none;">
            <p class="labelPhone">
                Telefoonnummer spelleider:
            </p>
            <InputView v-model="phoneNumber" :uppercase="false" hint="06-..." class="inputPhone" />
            <p class="notePhone">
                (Dit nummer wordt getoond aan de spelers als de 'Autoriteit Persoonsgegevens')
            </p>
        </div>
        <div>
            <p class="labelEmail">
                E-mailadressen spelers:
            </p>
            <div v-for="(email, index) in emails" :key="index" class="email-row">
                <InputView v-model="emails[index]" :uppercase="false" hint="email@voorbeeld.nl" class="inputEmail" />
                <button type="button" class="add-button" @click="addEmailField">+</button>
            </div>
        </div>
        <p class="labelScenario">
            Scenario:
        </p>
        <div class="start-buttons">
            <ButtonView :class="showShortScenarios ? '' : 'disabled'" text="Kort" @click="showShortScenarios ? create(2) : null" />
            <ButtonView :class="showShortScenarios ? '' : 'disabled'" text="Medium" @click="showShortScenarios ? create(1) : null" />
            <ButtonView text="Volledig" @click="create(0)" />
        </div>
    </div>
</template>

<script>
import api from '@/repository/api';
import InputView from '@/components/controlpanel/InputView.vue'
import ButtonView from '@/components/controlpanel/ButtonView.vue'

export default {
    data() {
        return {
            newAdminCodes: [],
            errorMessage: '',
            groupName: '',
            emails: [''],
            phoneNumber: ''
        }
    },
    computed: {
        showShortScenarios() {
            return process.env.VUE_APP_DISABLE_SHORT_SCENARIOS !== 'true';
        }
    },
    methods: {
        addEmailField() {
            this.emails.push('');
        },
        async copyToClipboard(text) {
            if (navigator.clipboard && navigator.clipboard.writeText) {
                await navigator.clipboard.writeText(text);
            } else {
                const textarea = document.createElement('textarea');
                textarea.value = text;
                textarea.style.position = 'fixed';
                textarea.style.left = '-9999px';
                document.body.appendChild(textarea);
                textarea.select();
                document.execCommand('copy');
                document.body.removeChild(textarea);
            }

            this.$bvToast.toast('Copied to clipboard!', {
                autoHideDelay: 2000,
                variant: 'success',
                solid: true,
                appendToast: false
            });
        },
        async create(variant) {
            this.errorMessage = '';
            const token = this.$store.state.sessionToken;
            try {
                const response = await api.createSession(token, variant, this.emails, this.phoneNumber, this.groupName);
                const data = response.data;
                console.log(data);
                this.newAdminCodes = data.data;
            } catch (error) {
                console.error(error);
                if (error.response && error.response.status === 409) {
                    this.errorMessage = 'Groepsnaam bestaat al. Kies een andere naam.';
                } else {
                    this.errorMessage = 'Er is iets misgegaan bij het aanmaken van de sessies.';
                }
            }
        }
    },
    components: { ButtonView, InputView }
}
</script>

<style scoped>
.new-admin-code {
    margin-top: 1rem;
}

.new-admin-code ul {
    list-style-type: none;
    padding: 0;
}

.new-admin-code li {
    margin: 0.25rem 0;
}

.start-buttons {
    display: flex;
}

.start-buttons .admin-button {
    margin: 0.5em;
}

.inputPhone {
    margin: 0.5em;
    width: 20em;
}

.notePhone {
    font-size: 0.75em;
}

.inputGroupName {
    margin: 0.5em;
    width: 20em;
}

.labelGroupName, .labelPhone, .labelEmail, .labelScenario {
    font-weight: bold;
    margin-top: 1.5em;
    margin-bottom: 0;
}

.email-row {
    display: flex;
    align-items: center;
}

.inputEmail {
    margin: 0.5em;
    width: 20em;
}

.add-button {
    margin: 0.5em;
    width: 2.5rem;
    height: 2.5rem;
    font-size: 1.5rem;
    line-height: 1;
    color: white;
    background: var(--color-primary);
    border: none;
    border-radius: 0.5rem;
    cursor: pointer;
}

.error-message {
    color: red;
    font-weight: bold;
}
.custom-table {
    width: 100%;
    border-collapse: collapse;
}

.custom-table th,
.custom-table td {
    text-align: left;
    padding: 8px;
}

tbody tr:nth-child(odd) {
    background-color: white;
}

.large {
    cursor: pointer;
}
</style>
